module.exports = "/src/views/games/other/images/action/kill.png";